import { useState } from "react";
import { Nav } from "../components/Nav";
import { Footer } from "../components/Footer";
import { api } from "../lib/api";
import { toast } from "sonner";

const TOPICS = ["Coaching & Overflow Academy", "The LifePrints™ Assessment", "Speaking / teaching invite", "Books & writing", "Music / Joy Reborn", "Ministry · Plan A Global", "Something else"];
const field = "bg-transparent border-b border-[#21302A]/20 focus:border-[#1E3A2B] outline-none px-0 py-3 w-full text-[#21302A] transition-colors";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", topic: TOPICS[0], message: "" });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      setSent(true);
      toast.success("Message sent!");
    } catch {
      toast.error("Could not send. Try again.");
    } finally { setLoading(false); }
  };

  return (
    <div className="bg-[#FAF4E9] min-h-screen">
      <Nav />
      <section className="max-w-5xl mx-auto px-6 pt-40 pb-24 grid md:grid-cols-2 gap-16">
        <div>
          <p className="eyebrow">Let's Build</p>
          <h1 className="font-serif-d text-4xl md:text-6xl text-[#1E3A2B] tracking-tighter mt-4">Work With <span className="italic-emph text-[#C0953A]">Coach Nata</span></h1>
          <p className="text-[#21302A]/70 mt-6">Coaching, a speaking invite, a collaboration, or just a hello — tell me where you are and what you're carrying.</p>
          <div className="mt-12 space-y-6 text-sm">
            <div><p className="eyebrow">Email</p><p className="mt-1 text-[#21302A]">joyreborncorp@gmail.com</p></div>
            <div><p className="eyebrow">Shop Email</p><p className="mt-1 text-[#21302A]">hausofnatashop@gmail.com</p></div>
            <div><p className="eyebrow">Based In</p><p className="mt-1 text-[#21302A]">Philadelphia, PA · Texas</p></div>
          </div>
        </div>
        <div>
          {sent ? (
            <div className="bg-[#1E3A2B] text-[#FAF4E9] p-10" data-testid="contact-success">
              <p className="font-serif-d text-3xl italic-emph text-[#DCBB6C]">Thank you.</p>
              <p className="mt-4 text-[#FAF4E9]/80">I read everything that comes through — and I respond. Watch your inbox.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-6" data-testid="contact-form">
              <input data-testid="contact-name" placeholder="Your Name" required className={field} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
              <input data-testid="contact-email" type="email" placeholder="Email" required className={field} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
              <select data-testid="contact-topic" className={field} value={form.topic} onChange={(e) => setForm({ ...form, topic: e.target.value })}>
                {TOPICS.map((t) => <option key={t}>{t}</option>)}
              </select>
              <textarea data-testid="contact-message" placeholder="Your Message" rows={4} required className={field} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
              <button data-testid="contact-submit" disabled={loading} className="w-full bg-[#1E3A2B] text-[#FAF4E9] hover:bg-[#2E5240] transition-colors py-4 uppercase tracking-widest text-xs font-medium disabled:opacity-50">
                {loading ? "Sending…" : "Send Message →"}
              </button>
            </form>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
}
